import { Typography } from "@platform/design-system";

import type { FieldComponent } from "../types";

const LabelComponent: FieldComponent<never> = ({ field }) => (
  <Typography
    variant={field.variant || "body-medium"}
    sx={{ mb: 2, ...field.sx }}
    className={field.className}
    style={field.style}
  >
    {field.label}
  </Typography>
);

export default LabelComponent;
